import universal from 'react-universal-component';

export default universal(() => import('./Custom'));



// WEBPACK FOOTER //
// ./src/app/views/Custom/index.js